/**
 * Created by user on 2018/4/29/029.
 */

import {
	BaseResourceLoader, IOptionsWithWindowOptionsWithResourceLoader,
	abstractResourceLoader,
	IOptionsResourceLoader, IResourceLoader, ITypeResourceLoader,
} from '@jsdom-extra/resource-loader';
import { JSDOM_ResourceLoader } from '@jsdom-extra/resource-loader/resource-loader';

export {
	BaseResourceLoader, IOptionsWithWindowOptionsWithResourceLoader,
	abstractResourceLoader,
	IOptionsResourceLoader, IResourceLoader, ITypeResourceLoader, JSDOM_ResourceLoader,
}

export default BaseResourceLoader;
